import { Link } from 'react-router-dom';
import {
    getVisibleDataManagerSteps,
    DATA_MANAGER_WORKSPACE_LABEL,
} from '../../constants/setupRoadmapSteps';
import { isPdsaMode } from '../../utils/appBranding';
import styles from '../admin/SetupRoadmap.module.css';

/**
 * Roadmap for Data Manager definition + Case Builder workflows.
 */
export default function DataManagerRoadmap() {
    const steps = getVisibleDataManagerSteps();
    const intro = isPdsaMode()
        ? 'Define stains, regions, and protocols, build cases, and import PathPresenter shares.'
        : 'Define stains, regions, and protocols, then build cases and assign slides.';

    return (
        <div className={styles.container}>
            <h1>{DATA_MANAGER_WORKSPACE_LABEL}</h1>
            <p className={styles.intro}>{intro}</p>
            <div className={styles.stepsGrid}>
                {steps.map((step) => (
                    <div key={step.id} className={styles.stepCard}>
                        <div className={styles.stepHeader}>
                            <div className={styles.stepNumber}>{step.number}</div>
                            <div className={styles.stepInfo}>
                                <h2 className={styles.stepTitle}>{step.title}</h2>
                            </div>
                        </div>
                        <p className={styles.stepDescription}>{step.description}</p>
                        <Link to={step.route} className={styles.stepLink}>
                            Open
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
}
